import {
  ADMINX_PAYMENTS_BY_DATE_FAIL,
  ADMINX_PAYMENTS_BY_DATE_REQUEST,
  ADMINX_PAYMENTS_BY_DATE_SUCCESS,
  CLIENT_PAYMENTS_BY_DATE_FAIL,
  CLIENT_PAYMENTS_BY_DATE_REQUEST,
  CLIENT_PAYMENTS_BY_DATE_SUCCESS,
  FAILED_PAYMENT_GET_ALL_FAIL,
  FAILED_PAYMENT_GET_ALL_REQUEST,
  FAILED_PAYMENT_GET_ALL_SUCCESS,
  GET_ADMINX_PAYMENTS_FAIL,
  GET_ADMINX_PAYMENTS_REQUEST,
  GET_ADMINX_PAYMENTS_SUCCESS,
  GET_ALL_PAYMENT_REPORTS,
  GET_CLIENT_PAYMENTS_FAIL,
  GET_CLIENT_PAYMENTS_REQUEST,
  GET_CLIENT_PAYMENTS_SUCCESS,
  GET_PAYMENT_REPORTS_FAIL,
  GET_PAYMENT_REPORTS_REQUEST,
  GET_PAYMENT_REPORTS_SUCCESS,
  GET_TEAM_PAYOUTS_FAIL,
  GET_TEAM_PAYOUTS_REQUEST,
  GET_TEAM_PAYOUTS_SUCCESS,
  GET_TRANSACTIONS_FAIL,
  GET_TRANSACTIONS_REQUEST,
  GET_TRANSACTIONS_SUCCESS,
  PAYMENT_GET_ALL_FAIL,
  PAYMENT_GET_ALL_REQUEST,
  PAYMENT_GET_ALL_SUCCESS,
  PAYMENTS_BY_DATE_FAIL,
  PAYMENTS_BY_DATE_REQUEST,
  PAYMENTS_BY_DATE_SUCCESS,
} from "../Constants/paymentConstants";
import api, { unwrapData } from "../service/api";

const getMessage = (error, fallback = "Request failed") =>
  error?.response?.data?.message || error?.response?.data?.error || error.message || fallback;

export const getPaymentReports = (page, limit) => async (dispatch) => {
  try {
    dispatch({ type: GET_PAYMENT_REPORTS_REQUEST });
    const { data } = await api.get(`payment/reports?page=${page}&limit=${limit}`);
    dispatch({ type: GET_PAYMENT_REPORTS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_PAYMENT_REPORTS_FAIL, payload: getMessage(error) });
  }
};

export const getAllPaymentReports = () => async (dispatch) => {
  try {
    dispatch({ type: GET_PAYMENT_REPORTS_REQUEST });
    const { data } = await api.get("payment/reports?limit=all");
    dispatch({ type: GET_ALL_PAYMENT_REPORTS, payload: data });
  } catch (error) {
    dispatch({ type: GET_PAYMENT_REPORTS_FAIL, payload: getMessage(error) });
  }
};

export const getPaymentsByDate = (startDate, endDate) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENTS_BY_DATE_REQUEST });
    const queryParams = new URLSearchParams({
      start: startDate,
      end: endDate,
    }).toString();
    const { data } = await api.get(`payment/reports/date?${queryParams}`);
    dispatch({
      type: PAYMENTS_BY_DATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PAYMENTS_BY_DATE_FAIL,
      payload: getMessage(error),
    });
  }
};

export const getTeamPayouts = (page, limit) => async (dispatch) => {
  try {
    dispatch({ type: GET_TEAM_PAYOUTS_REQUEST });
    const { data } = await api.get(
      `payment/payout-reports?page=${page}&limit=${limit}`
    );
    dispatch({ type: GET_TEAM_PAYOUTS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_TEAM_PAYOUTS_FAIL, payload: getMessage(error) });
  }
};

export const getClientPayments =
  ({ clientId, page = 1, limit = 25, start = null, end = null }) =>
  async (dispatch) => {
    try {
      dispatch({ type: GET_CLIENT_PAYMENTS_REQUEST });

      const body = {
        clientId,
        page,
        limit,
      };
      if (start && end) {
        body.start = start;
        body.end = end;
      }

      const { data } = await api.post("payment/client", body);

      dispatch({
        type: GET_CLIENT_PAYMENTS_SUCCESS,
        payload: { ...data, isAll: limit === "all" },
      });
    } catch (error) {
      dispatch({ type: GET_CLIENT_PAYMENTS_FAIL, payload: getMessage(error) });
    }
  };

export const getAllFailedPayments = () => async (dispatch) => {
  try {
    dispatch({ type: FAILED_PAYMENT_GET_ALL_REQUEST });
    const { data } = await api.get("payment/failed");
    dispatch({
      type: FAILED_PAYMENT_GET_ALL_SUCCESS,
      payload: unwrapData(data, "failedPayments"),
    });
  } catch (error) {
    dispatch({ type: FAILED_PAYMENT_GET_ALL_FAIL, payload: getMessage(error) });
  }
};

export const getAdminXReports =
  (id, page = 1, limit = 15) =>
  async (dispatch) => {
    try {
      dispatch({ type: GET_ADMINX_PAYMENTS_REQUEST });

      const { data } = await api.get(
        `payment/reports/adminx/${id}?page=${page}&limit=${limit}`
      );
      dispatch({
        type: GET_ADMINX_PAYMENTS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_ADMINX_PAYMENTS_FAIL,
        payload: getMessage(error),
      });
    }
  };

export const getAdminXReportsByDate =
  (id, startDate, endDate) => async (dispatch) => {
    try {
      dispatch({ type: ADMINX_PAYMENTS_BY_DATE_REQUEST });

      const queryParams = new URLSearchParams({
        start: startDate,
        end: endDate,
      }).toString();

      const { data } = await api.get(
        `payment/reports/adminx/date/${id}?${queryParams}`
      );

      dispatch({
        type: ADMINX_PAYMENTS_BY_DATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: ADMINX_PAYMENTS_BY_DATE_FAIL,
        payload: getMessage(error),
      });
    }
  };
